import { EventCategorySet } from "./attributes/EventCategorySet";
import { EventLocationSet } from "./attributes/EventLocationSet";
import { EventStatusSet } from "./attributes/EventStatusSet";
import { type EventFilterOption } from "./EventFilterOption";

export const eventFilterOptions: EventFilterOption[] = [
  {
    rank: 1,
    icon: "🏷️",
    label: "Category",
    attribute: EventCategorySet,
  },
  {
    rank: 2,
    icon: "🚦",
    label: "Status",
    attribute: EventStatusSet,
  },
  {
    rank: 3,
    icon: "📍",
    label: "Location",
    attribute: EventLocationSet,
  },
];
